import { PreferenceList, PreferenceSummary, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/me/preferences` — o que a pessoa logada escolheu para as telas dela
 * nesta loja (F127): as colunas das listas, o último modelo de etiqueta.
 */
export const fetchPreferences = async (signal) => PreferenceList.parse(await request('/api/v1/me/preferences', { ...(signal ? { signal } : {}) }));
export const savePreference = async (key, input) => PreferenceSummary.parse(await request(`/api/v1/me/preferences/${key}`, {
    method: 'PUT',
    body: input,
}));
//# sourceMappingURL=preferences.js.map